// @ts-nocheck
import { useEffect, useState } from 'react'
import { Box, Button, DialogTitle, DialogActions, DialogContent, Stack } from '@mui/material'
import { Formik, Form, useFormikContext } from 'formik'
import { LoadingButton } from '@mui/lab'
import { YearlyDetailsTable } from './YearlyDetailsTable'
import { TestResults } from './TestResults'
import { YearlessDetailsForm } from './YearlessDetailsForm'
import { GeometryPicker } from './GeometryPicker'
import DETAIL_TEMPLATES from './details/detail_templates.json'
import { useGenerateTestField } from '@cibo/landmanager'
import { prop, pluck, partition, uniq } from 'ramda'
import { useAllRequirements } from '../../hooks'

const buildDetailSet = (values: any) => {
  // expose which templates are being used so we can automate
  console.log(
    Object.values(values)
      .filter(Boolean)
      .map(value => [value.traitId, value.label, value.detail.year])
  )
  return Object.values(values).map(prop('detail')).filter(Boolean)
}

type RichTestFieldFormProps = {
  requestClose(): void
}

const RichTestFieldForm = ({ requestClose }: RichTestFieldFormProps) => {
  const [details, setDetails] = useState()
  const { values } = useFormikContext()
  const { generateTestField } = useGenerateTestField()
  const [geometryUpdateKey, setGeometryUpdateKey] = useState(0)

  useEffect(() => {
    const testDetails = buildDetailSet(values)

    setDetails(testDetails)
  }, [values])

  const onClickCreate = () => {
    generateTestField(details, { labels: ['rich test field', 'noAutoCibo'] })
    setGeometryUpdateKey(Math.random())
  }

  return (
    <Form>
      <DialogTitle>Rich Test Field</DialogTitle>

      <Box style={{ marginLeft: 16 }}>
        <GeometryPicker key={geometryUpdateKey} />
      </Box>

      <DialogContent>
        <Stack direction="row" spacing={3}>
          <Box sx={{ flex: 1 }}>
            <YearlessDetailsForm />
          </Box>
          <Box>
            <TestResults details={details} />
          </Box>
        </Stack>
      </DialogContent>

      <DialogContent>
        <YearlyDetailsTable />
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={requestClose}>
          Close
        </Button>
        <LoadingButton variant="contained" onClick={onClickCreate}>
          Create Field
        </LoadingButton>
      </DialogActions>
    </Form>
  )
}

export const RichTestField = (props: RichTestFieldFormProps) => {
  const requirements = useAllRequirements()

  if (requirements.isLoading) {
    return null
  }

  const [yearlyRequirements, yearlessRequirements] = partition(
    ({ year }) => !!year && year !== -1,
    requirements.data
  )
  const yearlyTraits = pluck('traitId', yearlyRequirements)
  const yearlessTraits = pluck('traitId', yearlessRequirements)
  const defaultTemplates = DETAIL_TEMPLATES.filter(prop('default'))

  const years = uniq(pluck('year', yearlyRequirements)).sort()

  const initialValues = {}

  defaultTemplates.forEach(template => {
    if (yearlessTraits.includes(template.traitId)) {
      initialValues[template.traitId] = template
    } else if (yearlyTraits.includes(template.traitId)) {
      years.forEach(year => {
        initialValues[`${template.traitId}-${year}`] = {
          ...template,
          detail: { ...template.detail, year },
        }
      })
    }
  })

  return (
    <Formik initialValues={initialValues} onSubmit={async values => {}}>
      <RichTestFieldForm {...props} />
    </Formik>
  )
}
